<template>
  <div class="detail">
    <div class="banner">
      <van-image width="100%" fit="cover" :src="publicUrl + detail.quizMainPic" />
      <div class="random"><span>{{getRandom(150,300)}}</span>人在测</div>
      <div class="info">
        <h1>{{detail.quizName}}</h1>
        <p>{{detail.quizIntro}}</p>
        <div>
          <div class="sprice">¥{{detail.h5SalePrice}}</div>
          <div class="oprice">¥{{detail.quizPrice}}</div>
          <div>精选{{detail.sortNum}}道 | 已测{{handleUserCount(detail.userCount)}}人</div>
        </div>
      </div>
    </div>
    <div class="tab-wrapper">
      <van-tabs v-model="active" scrollspy sticky>
        <van-tab title="测试介绍">
          <div class="detail_wrap" v-html="detail.quizMobileContent"></div>
        </van-tab>
        <van-tab title="用户评价">
          <div></div>
        </van-tab>
      </van-tabs>

      <div style="margin-bottom:60px">
        <my-cell :title="'本周热卖'" :isShowArrow="false" />
        <Hot />
      </div>

    </div>
    <van-goods-action>
      <van-goods-action-icon icon="wap-home" text="首页" @click="toHome" />
      <van-goods-action-icon icon="like" :class="{ 'iconactive': isActive }" @click="fav" text="收藏" />
      <van-goods-action-button class="button" type="warning" @click="toTest">¥{{detail.h5SalePrice }}&emsp;立即赠送</van-goods-action-button>
    </van-goods-action>
  </div>
</template>

<script>
  import * as api from "@p/api";
  import {
    Toast
  } from "vant";
  import publicUrl from "@p/public";
  import VanImage from "@m/vant/Image";
  import GoodAction from "@m/vant/GoodAction";
  import Tab from "@m/vant/Tab";
  import {
    handleUserCount
  } from "@p/util.js";
  import MyCell from "@c/MyCell.vue";
  import Hot from "@c/Hot.vue";
  export default {
    mixins: [VanImage, GoodAction, Tab],
    data() {
      return {
        publicUrl,
        detail: {},
        commentList: [],
        active: "1",
        tab: [{
            name: "测试介绍",
            index: 1
          },
          {
            name: "用户评价",
            index: 2
          }
        ],
        isActive: false
      };
    },

    components: {
      MyCell,
      Hot
    },

    watch: {
      $route() {
        this.quiz();
      }
    },
    created() {
      this.quiz();
      // this.getCommentList();
    },

    methods: {
      handleUserCount,
      getRandom(x, y) {
        return parseInt(Math.random() * (y - x + 1) + x);
      },
      async quiz() {
        //requestApiByGet
        var quizId = this.$route.query.quizId;
        var res = await api.requestApiByGet("quiz", quizId);
        console.log(res);
        if (res.code === 0) {
          this.detail = res.data;
          this.buttonText = "¥" + res.data.h5SalePrice + "      " + "立即赠送";
          var foot = localStorage.getItem('foot')
          var footIds = []
          if (foot) {
            footIds = JSON.parse(foot);
            if (footIds.indexOf(res.data.id) >= 0) {
              footIds.splice(footIds.indexOf(res.data.id), 1);
            }
            footIds.push(res.data.id);
            localStorage.setItem('foot', JSON.stringify(footIds));
          } else {
            footIds.push(res.data.id);
            localStorage.setItem('foot', JSON.stringify(footIds));
          }
        }
      },
      async getCommentList() {
        var quizId = this.$route.query.quizId;
        var res = await api.requestApiByGet("commentList", quizId);
        console.log(res);
        if (res.code === 0) {
          this.commentList = res.data;
        }
      },
      async toTest() {
        var userId = localStorage.getItem('userId')
        if (!userId) {
          this.$router.push('mine');
          return;
        }
        var params = {
          order: {
            quizId: this.$route.query.quizId,
            userId: userId,
            promoteRecordId: ""
          },
          couponRecord: {}
        };
        var res = await api.requestApiByPost("giftOrder", params);
        if (res.code === 0) {
          console.log(res)
          // this.$router.push({
          //   path: "know",
          //   query: {
          //     quizId: this.detail.id,
          //     timeLimit: this.detail.timeLimit,
          //     orderId: res.data.order.id
          //   }
          // });
        }
      },
      toHome() {
        this.$router.push("/home");
      },
      async fav() {
        var params = {
          quizId: this.$route.query.quizId
        };
        var res = await api.requestApiPost("fav", params);
        console.log(res);
        if (res.code === 0) {
          if (this.isActive) {
            Toast("取消收藏");
            this.isActive = false;
          } else {
            Toast("收藏成功");
            this.isActive = true;
          }
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .banner {
    background: #fff;
    border-bottom: 2px solid @gray-4;
    position: relative;

    .random {
      position: absolute;
      left: 0;
      top: 80px;
      z-index: 9;
      background: rgba(0, 0, 0, 0.7);
      padding: 8px;
      border-radius: 0 20px 20px 0;
      font-size: @font-size-md;
      color: #fff;

      span {
        color: @orange;
      }
    }

    .info {
      padding: 10px;

      h1 {
        font-size: @font-size-lg;
        color: @gray-8;
        line-height: 2;
      }

      p {
        font-size: @font-size-sm;
        color: @gray-6;
      }

      >div {
        overflow: hidden;
        margin-top: 10px;
        padding-bottom: 5px;

        .oprice {
          float: left;
          color: @gray-6;
          font-size: @font-size-md;
          text-decoration: line-through;
          margin: 0 5px 0 5px;
          padding-top: 5px;
        }

        .sprice {
          float: left;
          width: 20px;
          text-align: center;
          font-weight: @font-weight-bold;
          font-size: @font-size-md;
          border-radius: 10px;
          padding: 5px 20px;
          color: @orange;
          background: #fff5ee;
        }

        >div {
          float: right;
          font-size: @font-size-md;
          color: @gray-8;
          padding-top: 5px;
        }
      }
    }
  }

  .detail_wrap {
    margin-top: 10px;
    padding-bottom: 50px;
  }

  .van-goods-action {
    z-index: 2;
  }

  .iconactive {
    /deep/.van-icon {
      color: @red  !important;
      transition: 0.2s;
    }
  }
</style>
